<script>
  import { onMount } from "svelte";
  import { format } from "d3-format";

  import Icon from "./Icon.svelte";
  import { getNumberWithUnits, scaleCanvas } from "./../utils";
  import { calculator } from "./../content/data.json";

  const shareHandles = (calculator.share_handles || "")
    .split(",")
    .filter(d => d)
    .map(d => d.trim());

  export let name = "";
  export let label = "";
  export let lives = 0;
  export let cost = 0;
  export let selectedTarget = "";
  export let selectedTargetLabel = "";

  const lineHeight = 83;
  const width = 1200;
  const height = 620;

  let canvasElement;
  let rawImage = "";

  const draw = () => {
    if (!canvasElement) {
      setTimeout(draw, 200);
      return;
    }
    const ctx = canvasElement.getContext("2d");

    scaleCanvas(canvasElement, ctx, width, height);

    ctx.fillStyle = "#F5F5F9";
    ctx.fillRect(0, 0, width, height);

    let logo = new Image();
    logo.src = "/assets/logo.png";
    logo.onload = () => {
      ctx.drawImage(logo, 60, height - 90);
      rawImage = canvasElement.toDataURL("image/png");
    };

    let icon = new Image();
    const iconFilename = {
      CE: "ce-icon",
      NZ: "nz-icon"
    }[selectedTarget];
    icon.src = `/assets/${iconFilename}.png`;
    icon.onload = function() {
      ctx.drawImage(
        icon,
        width - icon.naturalWidth - 60,
        height - icon.naturalHeight - 40
      );
      rawImage = canvasElement.toDataURL("image/png");
    };

    const textParts = [
      [`If`],
      [name, "name"],
      [`achieves`],
      [`${selectedTargetLabel}`],
      ["by 2050,"],
      [`we would save`],
      [
        [
          getNumberWithUnits(lives),
          Math.round(lives) == 1 ? "life" : "lives"
        ].join(" "),
        "metric"
      ],
      ["and avoid"],
      [`$${getNumberWithUnits(cost)}`, "metric"],
      [`in adaptation costs`],
      [`globally through 2100.`]
    ];

    const xPadding = 60;
    let runningX = xPadding;
    let runningY = 140;
    textParts.forEach(([str, type = "normal"]) => {
      const fontWeight = type == "name" ? 800 : type == "metric" ? 800 : 400;
      ctx.font = `${fontWeight} 50px 'din pro', sans-serif`;

      const textWidth = ctx.measureText(str).width;

      if (runningX + textWidth > width - xPadding) {
        runningX = xPadding;
        runningY += lineHeight;
      }

      // add white background
      // if (type == "metric") {
      //   runningX += 5;
      //   ctx.fillStyle = "white";
      //   ctx.fillRect(
      //     runningX - 10,
      //     runningY - lineHeight + 24,
      //     textWidth + 18,
      //     lineHeight
      //   );
      // }

      ctx.fillStyle = type == "metric" ? "#55c7d2" : "#0b0a25";
      ctx.fillText(str, runningX, runningY);
      runningX += textWidth + 10;
      if (type == "metric") {
        runningX += 5;
      }
    });

    let runningHandlesY = height - 73;
    const handlesX = xPadding + 210;
    shareHandles.forEach((str, i) => {
      ctx.fillStyle = "#0b0a25";

      if (str[0] == "@") {
        let twitterIcon = new Image();
        twitterIcon.src = `/assets/twitter-icon.png`;
        let twitterIconY = runningHandlesY;
        twitterIcon.onload = function() {
          ctx.drawImage(
            twitterIcon,
            handlesX - twitterIcon.naturalWidth - 8,
            twitterIconY - twitterIcon.naturalHeight + 3
          );
          rawImage = canvasElement.toDataURL("image/png");
        };

        ctx.font = `500 17px 'Verdana', monospace`;
        ctx.fillText("@", handlesX, runningHandlesY);
        const atWidth = ctx.measureText("@").width;

        ctx.font = `500 17px 'din pro', sans-serif`;
        ctx.fillText(str.slice(1), handlesX + atWidth + 2, runningHandlesY);
      } else {
        ctx.font = `500 17px 'din pro', sans-serif`;
        ctx.fillText(str, handlesX, runningHandlesY);
      }

      runningHandlesY += 20;
    });

    rawImage = canvasElement.toDataURL("image/png");
  };

  $: name, selectedTargetLabel, draw();
  onMount(() => {
    draw();
  });
</script>

<canvas {width} {height} bind:this="{canvasElement}"></canvas>
<a href="{rawImage}" download="{`${name}-${selectedTargetLabel}.png`}">
  <Icon name="download" />
</a>

<style>
  canvas {
    display: none;
  }
</style>
